import { AvatarUserType } from '@crm/components/Avatar/utils'

export const getUserFullName = (
  user?: AvatarUserType,
  isShortName?: boolean
) => {
  if (!user || (!user.first_name && !user.last_name)) return '-'

  return isShortName
    ? [user.first_name?.[0], user.last_name?.[0]]?.join('')
    : [user?.first_name, user?.last_name]?.join(' ')
}

export const getInitials = (fullName: string) =>
  fullName
    .split(' ')
    .map((name) => name[0])
    .join('')
